import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { FormArray, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { IClient, IClientContact } from '../clients.interface';
import { ClientsService } from '../clients.service';
import { ClientTypes } from '../clients.constants';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { LocationPickerModalComponent } from '../../../../shared/components/location-picker-modal/location-picker-modal.component';
import { ILocation } from '../../../../shared/components/location-modal/location-modal.interfaces';
import { ExternalRequestService } from '../../../../shared/components/external-request/external-request.service';
import { TaskMovementsComponent } from '../../../tasks-page/tasks/task-movements/task-movements.component';

let self: any;

@Component({
  selector: 'app-clients-modal',
  templateUrl: './clients-modal.component.html',
  styleUrls: ['./clients-modal.component.css']
})
export class ClientsModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  showEdit: boolean = true;
  loading: boolean = false;
  saving: boolean = false;
  client!: IClient;
  clientTaskRequest: any;
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;
  clientTypes = ClientTypes;
  toBilling = false;

  constructor(
    public _ClientsService: ClientsService,
    private _ExternalRequestService: ExternalRequestService,
    private _dialogService: DialogService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
    private _AuthService: AuthService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.isDev = this._AuthService.isRole('dev');
    console.log(this.client)
    console.log(this.clientTaskRequest)
    if (this.client?._id) this.getClient();
    else this.buildForm();
  }

  getClient() {
    this.loading = true;
    this._ClientsService.getClient(this.client._id || '').subscribe((client) => {
      console.log(client)
      this.client = client;
      this.buildForm();
    });
  }

  get f() { return this.form.controls; }
  async buildForm() {
    if (this.clientTaskRequest) {
      let clientTR: IClient = {
        clientType: this.clientTaskRequest?.lastname ? 'PERSON' : 'COMPANY',
        firstname: this.clientTaskRequest?.firstname,
        lastname: this.clientTaskRequest?.lastname,
        nit: this.clientTaskRequest?.nit,
        addresses: [{ address: this.clientTaskRequest?.address, coordinates: this.clientTaskRequest?.location, type: undefined }],
        emails: [{ address: this.clientTaskRequest?.email, type: null }],
        phones: [{ number: this.clientTaskRequest?.phone, type: null }],
      }


      let phones: any[] = [];
      let emails: any[] = [];
      let addresses: any[] = [];
      let contacts = [];

      if (clientTR?.phones) {
        clientTR.phones.forEach((element: any) => {
          phones.push(this.newPhone(element.type, element.number));
        });
      }

      if (clientTR?.clientContacts) {
        for (const element of clientTR.clientContacts) {
          contacts.push(await this.newContact(element as IClientContact));
        }
      }

      if (clientTR?.emails) {
        clientTR.emails.forEach((element: any) => {
          emails.push(this.newEmail(element.type, element.address));
        });
      }

      if (clientTR?.addresses) {
        clientTR.addresses.forEach(element => {
          addresses.push(this.newAddress(element.type, element.address, _.get(element, 'coordinates[0]', 0), _.get(element, 'coordinates[1]', 0)));
        });
      }
      console.log(phones, emails, addresses, contacts)

      this.form = this.fb.group({
        lastname: [clientTR.lastname],
        firstname: [clientTR.firstname, [Validators.required]],
        corporatename: [clientTR.firstname, [Validators.required]],
        phones: this.fb.array(phones),
        emails: this.fb.array(emails),
        addresses: this.fb.array(addresses),
        nit: [clientTR.nit],
        isDeleted: [],
        clientType: [clientTR.clientType || 'PERSON', [Validators.required]],
        clientContacts: this.fb.array(contacts),
        taxAddress: []
      }, {
        validators: [
          toBillingValidator(this.toBilling),
        ]
      })

      console.log(this.form)
    } else {

      let phones: any = [];
      let emails: any = [];
      let addresses: any = [];
      let contacts = [];

      if (this.client.phones) {
        this.client.phones.forEach((element: any) => {
          phones.push(this.newPhone(element.type, element.number));
        });
      }

      if (this.client.clientContacts) {
        for (const element of this.client.clientContacts) {
          contacts.push(await this.newContact(element as IClientContact));
        }
      }

      if (this.client.emails) {
        this.client.emails.forEach((element: any) => {
          emails.push(this.newEmail(element.type, element.address));
        });
      }

      if (this.client.addresses) {
        this.client.addresses.forEach(element => {
          addresses.push(this.newAddress(element.type, element.address, _.get(element, 'coordinates[0]', 0), _.get(element, 'coordinates[1]', 0)));
        });
      }

      this.form = this.fb.group({
        lastname: [this.client.lastname],
        firstname: [this.client.firstname, [Validators.required]],
        corporatename: [this.client.corporatename, [Validators.required]],
        phones: this.fb.array(phones),
        emails: this.fb.array(emails),
        addresses: this.fb.array(addresses),
        nit: [this.client.nit],
        isDeleted: [this.client.isDeleted],
        clientType: [this.client.clientType || 'PERSON', [Validators.required]],
        clientContacts: this.fb.array(contacts),
        taxAddress: [this.client.taxAddress]
      }, {
        validators: [
          toBillingValidator(this.toBilling),
        ]
      })
    }
    this.loading = false;

    if (this.client?._id) this.form.markAllAsTouched();
  }

  setEditable(value: boolean = false) {
    this.readOnly = value;
  }

  // phones
  get phones() { return this.form.get("phones") as UntypedFormArray }
  newPhone(type?: '', number?: ''): UntypedFormGroup {
    return this.fb.group({ type: type, number: number, })
  }
  addPhone() { this.phones.push(this.newPhone()); }
  removePhone(i: number) { this.phones.removeAt(i); }

  // contacts
  get contacts() { return this.form.get("clientContacts") as UntypedFormArray }
  async newContact(contact?: IClientContact): Promise<UntypedFormGroup> {
    if (!contact) {
      contact = await this._ClientsService.createClientContact({
        firstname: '   ', lastname: '   ', position: '   ', email: '   ', phone: '   '
      }).toPromise() as IClientContact;
    }
    const _contact: any = contact;
    ['firstname', 'lastname', 'position', 'phone', 'email'].forEach(key => _contact[key] = _contact[key].trim());
    console.log(contact);
    return this.fb.group({
      _id: contact._id, firstname: contact.firstname, lastname: contact.lastname,
      position: contact.position, email: contact.email, phone: contact.phone,
    });
  }
  async addContact() { this.contacts.push(await this.newContact()); }
  removeContact(i: number) { this.contacts.removeAt(i); }

  // emails
  get emails() { return this.form.get("emails") as UntypedFormArray }
  newEmail(type?: '', address?: ''): UntypedFormGroup {
    return this.fb.group({
      type: type,
      address: address,
    })
  }
  addEmail() { this.emails.push(this.newEmail()); }
  removeEmail(i: number) { this.emails.removeAt(i); }

  // addresses
  get addresses() { return this.form.get("addresses") as UntypedFormArray }
  newAddress(type: string = '', address: string = '', latitude: number = 0, longitude: number = 0): UntypedFormGroup {
    return this.fb.group({
      type: type,
      address: address,
      latitude: latitude,
      longitude: longitude,
    })
  }
  addAddress() {
    this.addresses.push(this.newAddress());
    this.openGetLocationModal((this.form.get("addresses") as FormArray).controls.length - 1);
  }
  getAddress(i: number) { return (this.form.get("addresses") as FormArray).controls[i]; }
  removeAddress(i: number) { this.addresses.removeAt(i); }

  openGetLocationModal(i: number) {
    if (this.readOnly) return;
    let address = this.getAddress(i);
    let config = new MatDialogConfig();
    config.width = '900px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.locationDialogRef = this._dialog.open(LocationPickerModalComponent, config);
    let location: ILocation = {
      type: address ? address.get('type')?.value : '',
      address: address ? address.get('address')?.value : '',
      coordinates: [address ? address.get('latitude')?.value : 0, address ? address.get('longitude')?.value : 0]
    }
    self.locationDialogRef.componentInstance.initialLocation = location;

    self.locationDialogRef.afterClosed().subscribe((result: any) => {
      self.locationDialogRef = null;
      if (result) {
        try {
          // address.get('address').setValue(result.addressSearched, result.address);
          address.get('address')?.setValue(result.addressSearched || result.address);
          address.get('latitude')?.setValue(result.latitude);
          address.get('longitude')?.setValue(result.longitude);
        } catch (e) {
          console.log(e);
        }
      }
    });
  }

  async onSubmit() {
    this.submitted = true;
    let data: IClient = _.cloneDeep(this.form.value);

    if (data.clientType == 'PERSON') {
      data.lastname = data.lastname ? data.lastname.trim() : '';
      data.firstname = data.firstname ? data.firstname.trim() : '';
      data.corporatename = data.corporatename ? data.corporatename.trim() : (data.firstname + ' ' + data.lastname).trim();
      this.f['corporatename'].setValue(data.corporatename);
    } else {
      data.corporatename = data.corporatename ? data.corporatename.trim() : '';
      this.f['firstname'].setValue(data.corporatename);
      data.firstname = data.corporatename;
    }

    if (this.form.invalid) return;
    data.phones = data.phones.filter((el: any) => _.get(el, 'number', 0) > 0);
    data.emails = data.emails.filter((el: any) => _.get(el, 'address.length', 0) > 0);
    data.addresses = data.addresses?.filter(el => _.get(el, 'address.length', 0) > 0);

    this.saving = true;
    data.company = this._AuthService.companyId();
    if (data.addresses) {
      for (let i = 0; i < data.addresses.length; i++) {
        let location: ILocation = {
          type: data.addresses[i].type,
          address: data.addresses[i].address,
          coordinates: [(data.addresses[i] as any).latitude, (data.addresses[i] as any).longitude]
        }
        data.addresses[i] = location;
      }
    }
    if (data.clientContacts) {
      for (const contact of data.clientContacts) {
        await this._ClientsService.updateClientContact(contact as IClientContact).toPromise();
      }

      data.clientContacts = data.clientContacts.map((el: any) => el._id);
    }


    if (this.client?._id) {
      data._id = this.client._id;
      this._ClientsService.updateClient(data).subscribe({
        next: (client) => {
          this.dialog.close(client);
        }, error: err => {
          console.log(err);
          this.saving = false;
        }
      });
    } else {
      this._ClientsService.createClient(data).subscribe({
        next: (client) => {
          this.dialog.close(client);
        }, error: err => {
          console.log(err);
          this.saving = false;
        }
      });
    }
  }

  openMovementsModal() {
    let config = new MatDialogConfig();
    config.width = '1700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.movementsDialogRef = this._dialog.open(TaskMovementsComponent, config);
    self.movementsDialogRef.componentInstance.client = this.client;

    self.movementsDialogRef.afterClosed().subscribe((result: any) => {
      self.movementsDialogRef = null;
    });
  }

  cancelSubmit() {
    Object.keys(this.form.controls).forEach((key) => this.form.controls[key].setErrors(null));
    this.setEditable(true);
    this.getClient();
  }

  /*
  openShareTasksConfirm() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Compartir enlace",
      message: `Esta seguro que desea compartir listado de servicios de cliente cliente ${this.client.lastname || this.client.firstname || ''}?`,
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe(async (confirmation: any) => {
        if (confirmation) {
          const response = await this._ExternalRequestService.getTodayClientTasks(this.client);
          console.log(response._id);
          this._ExternalRequestService.openExternalRequest(response._id);
        }
      });
  }
  */

  getContactGroup(index: number): UntypedFormGroup {
    return this.contacts.controls[index] as UntypedFormGroup;
  }
}

function toBillingValidator(toBilling: boolean) {
  return (group: UntypedFormGroup) => {
    let firstnameControl = group.controls['firstname'];
    let nitControl = group.controls['nit'];
    let taxAddressControl = group.controls['taxAddress'];
    let errors = {};
    // console.log(firstnameControl.value)
    // console.log(nitControl.value)
    // console.log(taxAddressControl.value)

    if (toBilling) {
      if (!firstnameControl.value) { errors = { ...errors, nameBillingRequired: true }; }
      if (!nitControl.value) { errors = { ...errors, nitBillingRequired: true }; }
      if (!taxAddressControl.value) { errors = { ...errors, tABillingRequired: true }; }
    }

    if (Object.keys(errors).length === 0) {
      firstnameControl.setErrors(null);
      nitControl.setErrors(null);
      taxAddressControl.setErrors(null);
    } else {
      //console.log("errores ttt ",errors)
      firstnameControl.setErrors(errors);
      nitControl.setErrors(errors);
      taxAddressControl.setErrors(errors);
    }
  }
}